export const isClassicHistogramMetric = (metric: string) => metric.endsWith('_bucket');
